"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Contents = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_card_1 = require("@hopin-team/ui-card");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_hooks_1 = require("@hopin-team/ui-helper-hooks");

var ui_text_1 = require("@hopin-team/ui-text");

var use_id_1 = require("@hopin-team/use-id");

var focus_trap_react_1 = tslib_1.__importDefault(require("focus-trap-react"));

var react_1 = tslib_1.__importStar(require("react"));

var container_1 = require("../styled/container");

var contents_1 = require("../styled/contents");

var scroll_1 = require("../styled/scroll");

var Contents = function Contents(_a) {
  var _b = _a.backLabel,
      backLabel = _b === void 0 ? 'Go back' : _b,
      children = _a.children,
      _c = _a.closeLabel,
      closeLabel = _c === void 0 ? 'Close modal' : _c,
      describedById = _a.describedById,
      _d = _a.isDismissible,
      isDismissible = _d === void 0 ? true : _d,
      isInverse = _a.isInverse,
      _e = _a.type,
      type = _e === void 0 ? 'primary' : _e,
      _f = _a.size,
      size = _f === void 0 ? 'medium' : _f,
      withBackButton = _a.withBackButton,
      _g = _a.withCloseButton,
      withCloseButton = _g === void 0 ? isDismissible : _g,
      onBack = _a.onBack,
      onClose = _a.onClose,
      checkbox = _a.checkbox,
      footer = _a.footer,
      withSeparator = _a.withSeparator,
      title = _a.title,
      subtext = _a.subtext;
  (0, ui_helper_hooks_1.useOnKeyPress)('Escape', onClose, {
    isActive: isDismissible
  });
  var rootRef = (0, react_1.useRef)(null);
  (0, ui_helper_hooks_1.useOnClickOutside)(rootRef, onClose, {
    isActive: isDismissible
  });

  var _h = tslib_1.__read((0, react_1.useState)(null), 2),
      fallbackComponent = _h[0],
      setFallbackComponent = _h[1];

  var _j = tslib_1.__read((0, react_1.useState)(null), 2),
      scrollableContentComponent = _j[0],
      setScrollableContentComponent = _j[1]; // NOTE: Using callback ref pattern here, because FocusTrap component can only
  // mount when the focus fallbackComponent is mounted and available. Using this
  // pattern allows tracking changes in the ref state (as opposed to useRef).


  var fallbackRefCallback = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setFallbackComponent(node);
    }
  }, []);
  var focusTrapOptions = {
    fallbackFocus: fallbackComponent !== null && fallbackComponent !== void 0 ? fallbackComponent : '',
    allowOutsideClick: Boolean(isDismissible)
  };
  var scrollableContentRefCallback = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setScrollableContentComponent(node);
    }
  }, []);
  (0, ui_helper_hooks_1.useBodyLock)(scrollableContentComponent, true);
  var backgroundColor = isInverse ? 'grey-800' : 'grey-white';
  var isDialog = type === 'dialog';
  var bothSeparators = withSeparator === 'both';
  var labelledById = (0, use_id_1.useId)();
  return react_1.default.createElement(contents_1.ContentsRoot, {
    "aria-describedby": describedById,
    "aria-labelledby": labelledById,
    "aria-modal": true,
    ref: rootRef,
    role: isDialog ? 'alertdialog' : 'dialog',
    size: size,
    isDialog: isDialog
  }, react_1.default.createElement(ui_card_1.Card, {
    background: backgroundColor
  }, react_1.default.createElement("div", {
    ref: fallbackRefCallback
  }, fallbackComponent && react_1.default.createElement(focus_trap_react_1.default, {
    focusTrapOptions: focusTrapOptions
  }, react_1.default.createElement(container_1.ContentContainer, {
    size: size,
    isDialog: isDialog
  }, react_1.default.createElement(container_1.HeaderContainer, {
    background: backgroundColor,
    isInverse: isInverse,
    withSeparator: withSeparator === 'header' || bothSeparators,
    py: 2,
    px: 3
  }, react_1.default.createElement(ui_flex_1.Flex, {
    justifyContent: "space-between"
  }, react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center"
  }, withBackButton && react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "arrow-back",
    onClick: onBack,
    title: backLabel,
    pattern: isInverse ? 'inverse' : undefined,
    isGhost: true,
    mr: 2
  }), react_1.default.createElement(ui_text_1.Text, {
    element: "h3",
    pattern: "bodyLargeBold",
    id: labelledById
  }, title)), withCloseButton && react_1.default.createElement(ui_butticon_1.Butticon, {
    icon: "close",
    onClick: onClose,
    title: closeLabel,
    pattern: isInverse ? 'inverse' : undefined,
    isGhost: true
  })), react_1.default.createElement(ui_flex_1.Flex, {
    flexDirection: "column",
    ml: withBackButton ? 5 : 0
  }, subtext && react_1.default.createElement(ui_text_1.Text, {
    element: "p",
    pattern: "body",
    color: isInverse ? 'grey-white' : 'grey-medium'
  }, subtext), checkbox && checkbox)), react_1.default.createElement(scroll_1.Scroll, {
    ref: scrollableContentRefCallback,
    tabIndex: -1
  }, children), footer && react_1.default.createElement(container_1.Footer, {
    withSeparator: withSeparator === 'footer' || bothSeparators,
    isInverse: isInverse,
    isDialog: isDialog
  }, react_1.default.createElement(container_1.FooterContents, {
    background: backgroundColor,
    p: 3,
    isDialog: isDialog
  }, footer)))))));
};

exports.Contents = Contents;
Contents.displayName = 'ModalContents';